import { useLanguage } from "./Language";
import { PlaceHoldInfoImpl } from "./services/Holds";

export const useFailedHoldMessage = () => {
  const { translateToken } = useLanguage();
  const getFormattedGuardians = (
    guardians: PlaceHoldInfoImpl["guardiansBlocking"]
  ) => {
    const guardianNames = guardians.sort();
    switch (guardianNames.length) {
      case 1:
        return guardianNames[0];
      case 2:
        return guardianNames.join(" and ");
      default:
        return `${guardianNames.slice(0, -1).join(", ")}, and ${
          guardianNames[guardianNames.length - 1]
        }`;
    }
  };

  return (
    token: PlaceHoldInfoImpl["message"],
    guardiansBlocking: PlaceHoldInfoImpl["guardiansBlocking"]
  ) => {
    const message = translateToken(token);
    if (guardiansBlocking?.length > 0) {
      return `${message}: ${getFormattedGuardians(guardiansBlocking)}`;
    }
    return message;
  };
};
